import {SELECIONAR_VIAGEM_IDA} from '../../actions/types'

const initialState = null

export default function reducerViagemIda(state = initialState, action) {
    switch (action.type) {
        case SELECIONAR_VIAGEM_IDA: {
            if (!action.payload || action.payload.selecionada) {
                return initialState
            }
            return action.payload;
        }

        default: {
            return state
        }
    }
}
